module.exports = __webpack_public_path__ + "static/media/brandHalifax.aff50b09.jpg";